<template>
    <div class="card-deck">
        <slot />
    </div>
</template>

<script>
export default {

    name: 'CardDeck'

};
</script>
